// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

type GenericListItem = {id: string; name: string};

export interface DialogData_GenericListSelectionDialogInput<T extends GenericListItem> extends MatDialogDataBaseInput {
	availableItems: T[];
	selectedItemIds: string[];
	titleToken: string;
}

export interface DialogData_GenericListSelectionDialogOutput extends MatDialogDataBaseOutput {
	selectedItemIds: string[];
}

@Component({
	selector: "sim-generic-list-selection-dialog",
	templateUrl: "./generic-list-selection-dialog.component.html",
	styleUrls: ["./generic-list-selection-dialog.component.scss"],
	standalone: false,
})
export class GenericListSelectionDialogComponent<T extends GenericListItem>
	extends BasicMaterialDialog<
		GenericListSelectionDialogComponent<T>,
		DialogData_GenericListSelectionDialogInput<T>,
		DialogData_GenericListSelectionDialogOutput
	>
	implements OnInit
{
	public selectedItems: T[] = [];
	public unassignedItems: T[] = [];
	public selectedItemId: string = null;

	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit() {
		this.selectedItems = this.data.availableItems.filter((item) => this.data.selectedItemIds.includes(item.id));

		this.updateModels();
	}

	ok() {
		this.close({
			action: "ok",
			selectedItemIds: this.selectedItems.map((i) => i.id),
		});
	}

	public addSelectedItem(itemId: string) {
		const item = this.unassignedItems.find((item) => item.id === itemId);
		if (item && this.selectedItems.indexOf(item) < 0) {
			this.selectedItems.push(item);
			this.updateModels();
		}
	}

	public removeSelectedItem(item: T) {
		const index = this.selectedItems.indexOf(item);
		if (index >= 0) {
			this.selectedItems.splice(index, 1);
			this.updateModels();
		}
	}

	private updateModels() {
		this.selectedItems = this.data.availableItems.filter((item) => this.selectedItems.includes(item));
		this.unassignedItems = this.data.availableItems.filter((item) => !this.selectedItems.includes(item));
		this.selectedItemId = null;
	}

	public getItemName(item: T) {
		return item.name;
	}
}
